const catalogModelsPt = [
  {
    id: 'simple',
    titleUpper: 'CONVITE',
    titleScript: 'simples',
    desc: 'Solução elegante para eventos objetivos. Layout refinado, textos personalizados e entrega digital pronta para WhatsApp — ideal para aniversários, batizados e celebrações íntimas.',
    format: 'Imagem / PDF',
    themeLabel: 'Estilo clássico'
  },
  {
    id: 'interactive',
    titleUpper: 'CONVITE',
    titleScript: 'interativo',
    desc: 'Capa com interação por toque, navegação fluida e botões clicáveis. Experiência moderna para chá revelação, aniversários e eventos que pedem participação do convidado.',
    format: 'PDF interativo / link',
    themeLabel: 'Abertura interativa',
    showPlay: true
  },
  {
    id: 'interactiveInfinite',
    titleUpper: 'CONVITE',
    titleScript: 'interativo infinito',
    desc: 'Interação contínua com múltiplas telas, efeitos de transição e experiência imersiva. Para quem quer ir além do convite estático sem abrir mão da praticidade digital.',
    format: 'PDF interativo avançado / link',
    themeLabel: 'Navegação contínua',
    showPlay: true
  },
  {
    id: 'gifAnimated',
    titleUpper: 'CONVITE',
    titleScript: 'GIF animado',
    desc: 'Animação leve em formato GIF, perfeita para compartilhamento rápido. Visual dinâmico, personalização completa e excelente custo-benefício para festas e eventos sociais.',
    format: 'GIF animado',
    themeLabel: 'Motion leve',
    showPlay: true
  },
  {
    id: 'animated',
    titleUpper: 'CONVITE',
    titleScript: 'animado',
    desc: 'Vídeo MP4 com motion design, transições suaves e trilha sonora integrada. Apresentação cinematográfica para impressionar convidados desde a abertura.',
    format: 'Vídeo MP4',
    themeLabel: 'Animação premium',
    showPlay: true,
    showMusic: true
  },
  {
    id: 'superAnimated',
    titleUpper: 'CONVITE',
    titleScript: 'super animado',
    desc: 'Animações profissionais, personagens personalizados e produção sob medida. Alto impacto visual para festas infantis e celebrações que exigem wow factor.',
    format: 'Vídeo MP4',
    themeLabel: 'Tema princesa encantada',
    showPlay: true,
    showMusic: true
  },
  {
    id: 'sweet15',
    titleUpper: 'CONVITE 15 ANOS',
    titleScript: 'premium website',
    desc: 'Mini site sofisticado para debutantes com capa interativa, animações, identidade visual marcante e compartilhamento elegante via link ou WhatsApp.',
    format: 'Site',
    themeLabel: 'Tema conto de fadas',
    showPlay: true
  },
  {
    id: 'kidsCharacter',
    titleUpper: 'CONVITE INFANTIL MASCOTE',
    titleScript: 'premium website',
    desc: 'Experiência interativa com mascote personalizado, envelope animado, botões da festa e vídeo especial. Temas infantis seguros e 100% customizados pela WSJ.',
    format: 'Site',
    themeLabel: 'Tema ratinho clássico',
    showPlay: true,
    showMusic: true
  },
  {
    id: 'weddingPremium',
    titleUpper: 'CONVITE CASAMENTO',
    titleScript: 'premium',
    desc: 'Capa interativa com experiência emocionante, música, fotos e acabamento sofisticado. 100% personalizado para transmitir a essência do casal.',
    format: 'PDF + site ou link website',
    themeLabel: 'Romance premium',
    showPlay: true,
    showMusic: true
  },
  {
    id: 'babyRevealSimple',
    titleUpper: 'CONVITE CHÁ REVELAÇÃO',
    titleScript: 'simples',
    desc: 'Convite delicado e personalizado para chá revelação, ideal para compartilhar pelo WhatsApp com família e amigos.',
    format: 'Imagem / PDF',
    themeLabel: 'Chá revelação delicado'
  },
  {
    id: 'babyRevealInteractive',
    titleUpper: 'CONVITE CHÁ REVELAÇÃO',
    titleScript: 'interativo',
    desc: 'Experiência interativa com botões clicáveis, detalhes do evento e visual encantador para revelar esse momento especial.',
    format: 'PDF interativo / link',
    themeLabel: 'Interação especial',
    showPlay: true
  },
  {
    id: 'babyRevealPremiumWebsite',
    titleUpper: 'CONVITE CHÁ REVELAÇÃO',
    titleScript: 'premium website',
    desc: 'Página digital personalizada para chá revelação com animações, fotos, música, informações do evento e experiência premium no telemóvel.',
    format: 'Site',
    themeLabel: 'Experiência premium',
    showPlay: true,
    showMusic: true
  }
];

const ptBR = {
  metaTitle: 'Convites Digitais Premium | WSJ Soluções Digitais',
  badge: 'Convites Digitais',
  heroTitle: 'Convites digitais personalizados para momentos inesquecíveis',
  heroSubtitle:
    'Modelos modernos, animados e interativos para aniversários, casamentos, festas infantis e eventos especiais.',
  heroBadges: [
    'Aniversário infantil',
    'Casamento',
    '15 anos',
    'Chá revelação',
    'Batizado',
    'Corporativo',
    'Animado',
    'Website interativo'
  ],
  btnQuote: 'Pedir meu convite',
  btnModels: 'Ver modelos',
  btnWhatsapp: 'Falar no WhatsApp',
  btnOrderNow: 'Pedir agora',
  btnViewModel: 'Ver modelo',
  whatsappMessage: 'Olá, quero encomendar um convite digital.',
  orderWhatsappModelGeneric: 'Convite Digital',

  sectionCatalogTitle: 'Catálogo de modelos',
  sectionCatalogLead:
    'Escolha o formato ideal para o seu evento — do convite simples à experiência premium em website.',
  priceFromLabel: 'A partir',
  formatLabel: 'Formato',
  planCustomPriceLabel: 'Sob consulta',
  catalogModels: catalogModelsPt,

  sectionBenefitsTitle: 'Diferenciais WSJ',
  sectionBenefitsLead: 'Tudo o que você precisa para um convite digital premium, elegante e memorável.',
  benefits: [
    'Design personalizado',
    'Envio por WhatsApp',
    'Link interativo',
    'Música, fotos e vídeos',
    'Botão de localização',
    'Confirmação de presença',
    'Compatível com telemóvel',
    'Suporte durante a criação'
  ],

  sectionHowToOrderTitle: 'Como encomendar o seu convite?',
  howToOrderSteps: [
    { title: 'Escolha o modelo', desc: 'Navegue pelo catálogo e selecione o formato ideal para o seu evento.' },
    { title: 'Envie os dados do evento', desc: 'Compartilhe tema, textos, fotos, data, local e referências pelo WhatsApp.' },
    { title: 'Receba seu convite digital', desc: 'Após confirmação, entregamos o convite pronto para compartilhar com seus convidados.' }
  ],
  howToOrderNote:
    'Após a confirmação do pagamento, o prazo de entrega pode variar conforme o modelo escolhido e o nível de personalização.',

  sectionFaqTitle: 'Perguntas frequentes',
  sectionFaqLead: 'Tudo o que você precisa saber antes de pedir seu convite digital premium.',
  faqItems: [
    { q: 'O convite é enviado pelo WhatsApp?', a: 'Sim. Entregamos o convite pronto para compartilhar via WhatsApp, link ou QR Code — conforme formato do projeto.' },
    { q: 'Pode colocar música?', a: 'Sim. Modelos animados, super animados e websites premium incluem integração de música.' },
    { q: 'Pode ter animação?', a: 'Sim. Temos convites animados e super animados com motion design e efeitos profissionais.' },
    { q: 'Vocês fazem convite infantil?', a: 'Sim. Desenvolvemos convites infantis com temas personalizados como princesa encantada, safari infantil e boneca fashion.' },
    { q: 'Posso pedir alterações?', a: 'Sim. O processo inclui rodada de ajustes conforme modelo. Alterações extras podem ser orçadas separadamente.' },
    { q: 'Quanto tempo demora?', a: 'Depende do modelo e complexidade. Após confirmação do pagamento, o prazo varia conforme personalização escolhida.' },
    { q: 'O convite funciona no celular?', a: 'Sim. Todos os convites são pensados mobile first — experiência otimizada para smartphone.' },
    { q: 'Fazem convite premium animado?', a: 'Sim. Temos modelos super animados, premium website e experiências interativas de alto padrão.' }
  ],

  finalCtaTitle: 'Seu evento merece uma apresentação inesquecível.',
  finalCtaSubtitle:
    'A WSJ transforma convites em experiências digitais premium — elegantes, animadas e feitas sob medida para o seu momento.',

  heroMock: {
    weddingLabel: 'Casamento',
    birthdayLabel: 'Aniversário',
    kidsLabel: 'Infantil',
    animatedLabel: 'Animado',
    premiumLabel: 'Convite premium',
    interactiveLabel: 'Interativo com música'
  }
};

const ptPT = {
  ...ptBR,
  btnQuote: 'Pedir o meu convite',
  btnOrderNow: 'Pedir agora',
  btnViewModel: 'Ver modelo',
  whatsappMessage: 'Olá, quero encomendar um convite digital.',
  sectionCatalogLead:
    'Escolha o formato ideal para o seu evento — do convite simples à experiência premium em website.',
  howToOrderSteps: [
    { title: 'Escolha o modelo', desc: 'Navegue pelo catálogo e selecione o formato ideal para o seu evento.' },
    { title: 'Envie os dados do evento', desc: 'Partilhe tema, textos, fotos, data, local e referências pelo WhatsApp.' },
    { title: 'Receba o seu convite digital', desc: 'Após confirmação, entregamos o convite pronto para partilhar com os convidados.' }
  ],
  faqItems: [
    { q: 'O convite é enviado pelo WhatsApp?', a: 'Sim. Entregamos o convite pronto para partilhar via WhatsApp, link ou QR Code — conforme formato do projeto.' },
    { q: 'Pode colocar música?', a: 'Sim. Modelos animados, super animados e websites premium incluem integração de música.' },
    { q: 'Pode ter animação?', a: 'Sim. Temos convites animados e super animados com motion design e efeitos profissionais.' },
    { q: 'Fazem convite infantil?', a: 'Sim. Desenvolvemos convites infantis com temas personalizados como princesa encantada, safari infantil e boneca fashion.' },
    { q: 'Posso pedir alterações?', a: 'Sim. O processo inclui ronda de ajustes conforme modelo. Alterações extras podem ser orçadas separadamente.' },
    { q: 'Quanto tempo demora?', a: 'Depende do modelo e complexidade. Após confirmação do pagamento, o prazo varia conforme personalização escolhida.' },
    { q: 'O convite funciona no telemóvel?', a: 'Sim. Todos os convites são pensados mobile first — experiência optimizada para smartphone.' },
    { q: 'Fazem convite premium animado?', a: 'Sim. Temos modelos super animados, premium website e experiências interativas de alto padrão.' }
  ],
  benefits: [
    'Design personalizado',
    'Envio por WhatsApp',
    'Link interativo',
    'Música, fotos e vídeos',
    'Botão de localização',
    'Confirmação de presença',
    'Compatível com telemóvel',
    'Suporte durante a criação'
  ]
};

const catalogModelsEn = [
  {
    id: 'simple',
    titleUpper: 'SIMPLE',
    titleScript: 'digital invite',
    desc: 'Elegant solution for focused events. Refined layout, custom copy and digital delivery ready for WhatsApp — ideal for birthdays, christenings and intimate celebrations.',
    format: 'Image / PDF',
    themeLabel: 'Classic style'
  },
  {
    id: 'interactive',
    titleUpper: 'INTERACTIVE',
    titleScript: 'digital invite',
    desc: 'Touch-activated cover, smooth navigation and clickable buttons. Modern experience for gender reveals, birthdays and events that invite guest participation.',
    format: 'Interactive PDF / link',
    themeLabel: 'Interactive opening',
    showPlay: true
  },
  {
    id: 'interactiveInfinite',
    titleUpper: 'INFINITE INTERACTIVE',
    titleScript: 'digital invite',
    desc: 'Continuous interaction with multiple screens, transition effects and immersive flow. For clients who want more than a static invite with practical digital delivery.',
    format: 'Advanced interactive PDF / link',
    themeLabel: 'Continuous navigation',
    showPlay: true
  },
  {
    id: 'gifAnimated',
    titleUpper: 'ANIMATED GIF',
    titleScript: 'digital invite',
    desc: 'Light animation in GIF format, perfect for quick sharing. Dynamic visuals, full customisation and strong value for social events.',
    format: 'Animated GIF',
    themeLabel: 'Light motion',
    showPlay: true
  },
  {
    id: 'animated',
    titleUpper: 'ANIMATED',
    titleScript: 'digital invite',
    desc: 'MP4 video with motion design, smooth transitions and integrated soundtrack. Cinematic presentation to impress guests from the opening.',
    format: 'MP4 video',
    themeLabel: 'Premium animation',
    showPlay: true,
    showMusic: true
  },
  {
    id: 'superAnimated',
    titleUpper: 'SUPER ANIMATED',
    titleScript: 'digital invite',
    desc: 'Professional animations, custom characters and bespoke production. High visual impact for kids parties and celebrations that demand wow factor.',
    format: 'MP4 video',
    themeLabel: 'Enchanted princess theme',
    showPlay: true,
    showMusic: true
  },
  {
    id: 'sweet15',
    titleUpper: 'SWEET 15',
    titleScript: 'premium website',
    desc: 'Sophisticated mini site for debutantes with interactive cover, animations, striking visual identity and elegant link or WhatsApp sharing.',
    format: 'Website',
    themeLabel: 'Fairy tale theme',
    showPlay: true
  },
  {
    id: 'kidsCharacter',
    titleUpper: 'KIDS MASCOT',
    titleScript: 'premium website',
    desc: 'Interactive experience with custom mascot, animated envelope, party buttons and special video. Safe kids themes fully customised by WSJ.',
    format: 'Website',
    themeLabel: 'Classic mouse theme',
    showPlay: true,
    showMusic: true
  },
  {
    id: 'weddingPremium',
    titleUpper: 'WEDDING',
    titleScript: 'premium',
    desc: 'Interactive cover with emotional experience, music, photos and sophisticated finish. Fully personalised to reflect the couple.',
    format: 'PDF + site or website link',
    themeLabel: 'Premium romance',
    showPlay: true,
    showMusic: true
  },
  {
    id: 'babyRevealSimple',
    titleUpper: 'GENDER REVEAL',
    titleScript: 'simple',
    desc: 'Delicate, personalised gender reveal invite, ideal for sharing via WhatsApp with family and friends.',
    format: 'Image / PDF',
    themeLabel: 'Delicate reveal'
  },
  {
    id: 'babyRevealInteractive',
    titleUpper: 'GENDER REVEAL',
    titleScript: 'interactive',
    desc: 'Interactive experience with clickable buttons, event details and charming visuals to reveal this special moment.',
    format: 'Interactive PDF / link',
    themeLabel: 'Special interaction',
    showPlay: true
  },
  {
    id: 'babyRevealPremiumWebsite',
    titleUpper: 'GENDER REVEAL',
    titleScript: 'premium website',
    desc: 'Custom digital page for gender reveal with animations, photos, music, event information and premium mobile experience.',
    format: 'Website',
    themeLabel: 'Premium experience',
    showPlay: true,
    showMusic: true
  }
];

const enUS = {
  metaTitle: 'Premium Digital Invites | WSJ Soluções Digitais',
  badge: 'Digital Invites',
  heroTitle: 'Custom digital invites for unforgettable moments',
  heroSubtitle:
    'Modern, animated and interactive models for birthdays, weddings, kids parties and special events.',
  heroBadges: [
    'Kids birthday',
    'Wedding',
    'Sweet 15',
    'Gender reveal',
    'Christening',
    'Corporate',
    'Animated',
    'Interactive website'
  ],
  btnQuote: 'Order my invite',
  btnModels: 'View models',
  btnWhatsapp: 'WhatsApp',
  btnOrderNow: 'Order now',
  btnViewModel: 'View model',
  whatsappMessage: 'Hello, I would like to order a digital invite.',
  orderWhatsappModelGeneric: 'Digital Invite',

  sectionCatalogTitle: 'Model catalogue',
  sectionCatalogLead: 'Choose the ideal format for your event — from simple invites to premium website experiences.',
  priceFromLabel: 'From',
  formatLabel: 'Format',
  planCustomPriceLabel: 'Custom quote',
  catalogModels: catalogModelsEn,

  sectionBenefitsTitle: 'WSJ advantages',
  sectionBenefitsLead: 'Everything you need for a premium, elegant and memorable digital invite.',
  benefits: [
    'Custom design',
    'WhatsApp delivery',
    'Interactive link',
    'Music, photos and videos',
    'Location button',
    'RSVP confirmation',
    'Mobile compatible',
    'Support during creation'
  ],

  sectionHowToOrderTitle: 'How to order your invite?',
  howToOrderSteps: [
    { title: 'Choose your model', desc: 'Browse the catalogue and select the ideal format for your event.' },
    { title: 'Send event details', desc: 'Share theme, text, photos, date, location and references via WhatsApp.' },
    { title: 'Receive your digital invite', desc: 'After confirmation, we deliver your invite ready to share with guests.' }
  ],
  howToOrderNote:
    'After payment confirmation, delivery time may vary according to the chosen model and level of customisation.',

  sectionFaqTitle: 'FAQ',
  sectionFaqLead: 'Everything you need to know before ordering your premium digital invite.',
  faqItems: [
    { q: 'Is the invite sent via WhatsApp?', a: 'Yes. We deliver the invite ready to share via WhatsApp, link or QR Code — according to project format.' },
    { q: 'Can it include music?', a: 'Yes. Animated, super animated and premium website models include music integration.' },
    { q: 'Can it be animated?', a: 'Yes. We offer animated and super animated invites with motion design and professional effects.' },
    { q: 'Do you make kids invites?', a: 'Yes. We develop kids invites with custom themes like enchanted princess, safari and fashion doll.' },
    { q: 'Can I request changes?', a: 'Yes. The process includes adjustment rounds according to model. Extra revisions may be quoted separately.' },
    { q: 'How long does it take?', a: 'Depends on model and complexity. After payment confirmation, timing varies with customisation level.' },
    { q: 'Does the invite work on mobile?', a: 'Yes. All invites are mobile first — experience optimised for smartphones.' },
    { q: 'Do you make premium animated invites?', a: 'Yes. We offer super animated models, premium websites and high-end interactive experiences.' }
  ],

  finalCtaTitle: 'Your event deserves an unforgettable presentation.',
  finalCtaSubtitle: 'WSJ turns invites into premium digital experiences — elegant, animated and tailored to your moment.',

  heroMock: {
    weddingLabel: 'Wedding',
    birthdayLabel: 'Birthday',
    kidsLabel: 'Kids',
    animatedLabel: 'Animated',
    premiumLabel: 'Premium invite',
    interactiveLabel: 'Interactive with music'
  }
};

const fallbackLocales = ['es', 'fr', 'it', 'hi', 'de', 'nl', 'ru', 'ar', 'zh-CN', 'zh-TW'];

export const digitalInvitesPageByLang = {
  'pt-BR': ptBR,
  'pt-PT': ptPT,
  en: enUS,
  ...Object.fromEntries(fallbackLocales.map((code) => [code, enUS]))
};
